/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxGamesLibWebPlatformDataOptionsWindowsOptions } from './FxGamesLibWebPlatformDataOptionsWindowsOptions';
import {
    instanceOfFxGamesLibWebPlatformDataOptionsWindowsOptions,
    FxGamesLibWebPlatformDataOptionsWindowsOptionsFromJSON,
    FxGamesLibWebPlatformDataOptionsWindowsOptionsFromJSONTyped,
    FxGamesLibWebPlatformDataOptionsWindowsOptionsToJSON,
} from './FxGamesLibWebPlatformDataOptionsWindowsOptions';

/**
 * @type FxGamesLibWebPlatformDataOptionsWindows
 * 
 * @export
 */
export type FxGamesLibWebPlatformDataOptionsWindows = FxGamesLibWebPlatformDataOptionsWindowsOptions;

export function FxGamesLibWebPlatformDataOptionsWindowsFromJSON(json: any): FxGamesLibWebPlatformDataOptionsWindows {
    return FxGamesLibWebPlatformDataOptionsWindowsFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsWindowsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsWindows {
    if (json == null) {
        return json;
    }
    if (instanceOfFxGamesLibWebPlatformDataOptionsWindowsOptions(json)) {
        return FxGamesLibWebPlatformDataOptionsWindowsOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxGamesLibWebPlatformDataOptionsWindowsToJSON(json: any): any {
    return FxGamesLibWebPlatformDataOptionsWindowsToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsWindowsToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsWindows | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxGamesLibWebPlatformDataOptionsWindowsOptions(value)) {
        return FxGamesLibWebPlatformDataOptionsWindowsOptionsToJSON(value as FxGamesLibWebPlatformDataOptionsWindowsOptions);
    }

    return {};
}

